<script lang="ts" setup>
import { computed, useAttrs } from 'vue';
import { useGradeHelpers } from '@ilteducation/grade-helpers-vue';
import { useConfigHelper } from '@ilteducation/config';

const realm = useConfigHelper().getRealm();
const { getPossibleGrades, convertGradeToYearsInSchool } = useGradeHelpers(realm);
const groupGrades = getPossibleGrades().map((grade) => ({
  value: convertGradeToYearsInSchool(grade),
  title: grade,
}));

const attrs = useAttrs();

// VSelect puts role="combobox" on the field wrapper, while the label names the <input> inside it —
// the menu's activator props are the only way to give the wrapper the same name.
const menuProps = computed(() => ({
  activatorProps: { 'aria-label': (attrs['aria-label'] ?? attrs.label) as string | undefined },
}));
</script>

<template>
  <v-select
    name="grade"
    ref="selectRef"
    :items="groupGrades"
    :menu-props="menuProps"
    variant="outlined"
    density="default"
    hide-details="auto"
    bgColor="surface-bright"
    clearable
    clear-icon="mdi-close"
  ></v-select>
</template>
